import { CircleLayerSpecification, LineLayerSpecification, SymbolLayerSpecification } from 'mapbox-gl';

export const pointLayerStyle = (zoomLevel: number): CircleLayerSpecification => {
    return {
        id: 'points',
        source: 'points',
        type: 'circle',
        paint: {
            'circle-radius': zoomLevel * 1.5,
            'circle-color': ['get', 'color'],
            'circle-emissive-strength': 1 // Make color glow (important for Globe)
        },
    }
};

export const pointArrowLayerStyle = (zoomLevel: number): SymbolLayerSpecification => {
    return {
        id: 'vessel-arrows',
        source: 'points',
        type: 'symbol',
        layout: {
            'icon-image': ['concat', 'arrow-', ['get', 'color']], // Dynamically use the arrow icon with color
            'icon-size': zoomLevel * 0.08,
            'icon-rotate': ['get', 'heading'],
            'icon-allow-overlap': true,
            'icon-ignore-placement': true,            
        },
    };
};

export const lineLayerStyle = (): LineLayerSpecification => {
    return {
        id: 'lines',
        source: 'lines',
        type: 'line',
        paint: {
            'line-color': '#ffffff',   // White line
            'line-width': 1,           // Increase width for visibility         
            'line-emissive-strength': 1 // Make color glow (important for Globe)
        },
    };
};


export const pointArrowLayerStyleForVoyage = (): SymbolLayerSpecification => {
    return {
        id: 'vessel-arrows-for-voyage',
        source: 'voyageDailySignals',
        type: 'symbol',
        layout: {
            'icon-image': 'arrow-icon',
            'icon-size': .1,
            'icon-rotate': ['get', 'heading'],
            'icon-allow-overlap': true,
        },
    };
};


export const portCallsLayerStyle = (): CircleLayerSpecification => {
    return {
        id: 'portCalls',
        source: 'portCalls',
        type: 'circle',
        paint: {
            'circle-radius': 25,
            'circle-color': [
                'case',
                ['==', ['get', 'portActivity'], 'Load'],
                '#569FD3',
                ['==', ['get', 'portActivity'], 'Discharge'],
                '#DF6721',
                ['==', ['get', 'portActivity'], 'In Shipyard'],
                '#F0D035',
                ['==', ['get', 'portActivity'], 'In Shipbreaker'],
                '#F0D035',
                '#819391',
            ],
            'circle-opacity': 0.5,
            'circle-emissive-strength': 1 // Make color glow (important for Globe)
        },
    }
};


export const stoppagesLayerStyle: CircleLayerSpecification = {
    id: 'stoppages',
    source: 'stoppages',
    type: 'circle',
    paint: {
        'circle-radius': 4,
        'circle-color': '#ffffff',
        'circle-emissive-strength': 1 // Make color glow (important for Globe)
    },
};